import { render, staticRenderFns } from "./a2p-trust-bundle-table.vue?vue&type=template&id=1f1139be"
import script from "./a2p-trust-bundle-table.vue?vue&type=script&lang=js"
export * from "./a2p-trust-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports